// Libs
import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Container, Form } from 'react-bootstrap';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import TodoService from 'services/TodoService';
 
// Components
import Loader from 'components/common/Loader';
import TodosTable from 'components/todos/TodosTable';
import EditTodoModal from 'components/todos/EditTodoModal';
import PageHeader from 'components/common/PageHeader';
import SideBar from 'components/common/SideBar';
import FormChecks from 'components/common/FormChecks';

//-------------------------------------------------------------------------------------------------------------------

class TodosPage extends React.Component {

    constructor(props) {
        super(props);

        this.editTodoModalRef = React.createRef();

        this.requestID = 1;
        this.state = {
            //isLoadingFilters: true,
            isLoading: true,
            filters: {
                search: '',
                types: {

                }
            }
        };
        TodoService.types.forEach(t => this.state.filters.types[t] = true);
    }
    
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.load();

        // Load a specific todo
        const id = this.props.match.params.id;
        if (id) {
            this.editTodo(id);
        }
    }
    
    async load() {
        GlobalStateService.setValues({ area: 'todos' });
        this.requestID++;
        const todos = await TodoService.list(this.state.filters);
        this.setState({
            todos,
            isLoading: false
        });
    }

    async exportToExcel() {
        await TodoService.excel(this.state.filters, false);
    }

    debounceLoad() {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.load();
        }, 200);
    }

    updateFilter(name, value) {
        const filters = { ...this.state.filters };
        filters[name] = value;
        this.setState({
            filters
        }, () => {

            switch (name) {
                case 'search':
                    this.debounceLoad();
                    break;
                default:
                    this.load();
                    break;
            }

        });
    }

    updateFilterOptions(filterName, values) {
        const filters = { ...this.state.filters };
        const filter = { ...filters[filterName] };
        for (let option in values) {
            const value = values[option];
            if (value) {
                filter[option] = value;
            } else {
                delete filter[option];
            }
        }
        filters[filterName] = filter;
        this.updateFilter(filterName, filter);
    }
    
    async editTodo(id) {
        await this.editTodoModalRef.current.show({
            todoID: id
        });
        this.load();
    }

    async addTodo(type) {
        await this.editTodoModalRef.current.show({
            type
        });
        this.load();
    }

    render() {
        const {
            isLoading
        } = this.state;
        const loginInfo = GlobalStateService.getValue('loginInfo');

        return (<>
            <div className="page todos-page full-width-page">
                
                <PageHeader hasSideBar>
                    <h1>To-do list</h1>

                    <div className="buttons">

                        <div className="dropdown me-2">
                            <button className="btn btn-primary dropdown-toggle" type="button" id="actions-menu" data-bs-toggle="dropdown" aria-expanded="false">
                                <span className="d-none d-sm-inline">
                                    <span className="fa-solid fa-plus"></span>{' '}
                                    New to-do...
                                </span>
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="actions-menu">

                                <li>
                                    <Link className="dropdown-item" to="#" onClick={e => {
                                        e.preventDefault();
                                        this.addTodo('Booking');
                                    }}>
                                        Booking
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="#" onClick={e => {
                                        e.preventDefault();
                                        this.addTodo('Custom');
                                    }}>
                                        Custom to-do
                                    </Link>
                                </li>

                            </ul>

                        </div>

                        {loginInfo.site.enableExcelExport &&
                            <button className="btn btn-primary" onClick={e => this.exportToExcel()} disabled={isLoading}>
                                <span className="fa-solid fa-file-excel" />{' '}
                                Export
                            </button>
                        }

                    </div>
                </PageHeader>

                <main>

                    <SideBar content={this.renderSideBarContent()} className="flex" />

                    <Container fluid>
                        
                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>

            <EditTodoModal ref={this.editTodoModalRef} />

        </>);
    }

    renderInner() {
        const {
            isLoading,
            todos
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (<>

            <TodosTable
                requestID={this.requestID}
                todos={todos}
                onSelect={(todo) => {
                    this.editTodo(todo.id);
                }}
            />

            <EditTodoModal ref={this.editTodoModalRef} />

        </>);
    }

    renderSideBarContent() {
        const {
            isLoadingFilters,
            filters
        } = this.state;

        if (isLoadingFilters) {
            return (<Loader />);
        }

        const types = TodoService.types.map(t => ({ id: t, name: TodoService.getTypeName(t) }));

        return (<>
            <input
                type="search"
                className="form-control mb-3"
                placeholder="Search..."
                value={filters.search || ''}
                onChange={e => this.updateFilter('search', e.target.value)}
            />

            <Form.Group className="mb-3">
                <Form.Label>Type</Form.Label>
                <FormChecks
                    isScrolling
                    allowSelectAllNone
                    id="type"
                    options={types}
                    value={filters.types}
                    onChange={(values) => this.updateFilterOptions('types', values)}
                />
            </Form.Group>

            {/*
            <Form.Group className="mb-3">
                <Form.Label>Search...</Form.Label>
                <input
                    type="search"
                    autoFocus
                    className="form-control"
                    onChange={e => this.updateFilter('query', e.target.value)}
                />
            </Form.Group>
            */}
        </>);
    }
}

export default withRouter(TodosPage);